export class Segmentacao {
  id: number;
  descricao: string;
  descFrete: number;
  mostrarKitPronto: boolean;
  imagem$: Promise<string>;
  imagem: string;
}
